module.exports = __webpack_public_path__ + "img/enterpriseDeptDoc.c435ded5.svg";